import { ADMIN_ROUTE_PERMISSIONS, AdminPermission } from '@ivy-monorepo/shared'

const USERS_PAGE_PERMISSIONS = [
  AdminPermission.Users,
  AdminPermission.CheckedInUsers,
  AdminPermission.Admin,
  AdminPermission.AuthenticatedAccounts,
]

const USER_INTERACTIONS_PAGE_PERMISSIONS = [
  AdminPermission.Likes,
  AdminPermission.Blocks,
  AdminPermission.Conversations,
  AdminPermission.AuditLogs,
  AdminPermission.Intentions,
]

const VENUE_ACTIVITY_PAGE_PERMISSIONS = [
  AdminPermission.Visits,
  AdminPermission.Breadcrumbs,
  AdminPermission.Intentions,
]

export const resolveRoutePermission = (pathname: string): AdminPermission | undefined => {
  const normalizedPath = pathname.replace(/\/$/, '')

  if (
    normalizedPath === '/admin/users' ||
    normalizedPath === '/admin/user-interactions' ||
    normalizedPath === '/admin/venue-activity'
  ) {
    return undefined
  }

  if (ADMIN_ROUTE_PERMISSIONS[normalizedPath]) {
    return ADMIN_ROUTE_PERMISSIONS[normalizedPath]
  }

  if (normalizedPath.startsWith('/admin/users/')) {
    return undefined
  }

  if (normalizedPath.startsWith('/admin/venues/')) {
    return AdminPermission.Venues
  }

  if (normalizedPath.startsWith('/admin/venue-events/')) {
    return AdminPermission.Events
  }

  return undefined
}

export const canAccessRoute = (pathname: string, permissions: AdminPermission[]): boolean => {
  const normalizedPath = pathname.replace(/\/$/, '')

  if (normalizedPath === '/admin/users') {
    return USERS_PAGE_PERMISSIONS.some(permission => permissions.includes(permission))
  }

  if (normalizedPath === '/admin/user-interactions') {
    return USER_INTERACTIONS_PAGE_PERMISSIONS.some(permission => permissions.includes(permission))
  }

  if (normalizedPath === '/admin/venue-activity') {
    return VENUE_ACTIVITY_PAGE_PERMISSIONS.some(permission => permissions.includes(permission))
  }

  if (normalizedPath.startsWith('/admin/users/')) {
    return permissions.includes(AdminPermission.Users) || permissions.includes(AdminPermission.Admin)
  }

  const required = resolveRoutePermission(pathname)
  if (!required) {
    return true
  }
  return permissions.includes(required)
}

export const getFirstAccessibleAdminRoute = (permissions: AdminPermission[]): string | null => {
  if (USERS_PAGE_PERMISSIONS.some(permission => permissions.includes(permission))) {
    return '/admin/users'
  }

  if (USER_INTERACTIONS_PAGE_PERMISSIONS.some(permission => permissions.includes(permission))) {
    return '/admin/user-interactions'
  }

  if (VENUE_ACTIVITY_PAGE_PERMISSIONS.some(permission => permissions.includes(permission))) {
    return '/admin/venue-activity'
  }

  for (const [route, permission] of Object.entries(ADMIN_ROUTE_PERMISSIONS)) {
    if (permissions.includes(permission)) {
      return route
    }
  }
  return null
}
